<div class="boxPlan__headers gap-y-2">
    <div class="flex justify-between w-full items-center px-5">
        <div class="flex flex-row items-center gap-x-4 mt-4 justify-self-start">
            <div id="boxPlan_header_title">
                <div
                    class="boxPlan__header__title text-base flex flex-row items-center justify-center"
                    [class.boxPlan__header__title__detailsActive]="
                        synopticPlanInteractionService.planType() === PlanTypeEnum.BOX
                    ">
                    @if (planItems().length) {
                        <span class="block text-base">
                            {{ `synopticPlan.${synopticPlanInteractionService.planType()}` | transloco }}
                        </span>
                    }

                    <span> {{ headerValue() }}</span>
                </div>

                @if (planItems().length) {
                    <div class="boxPlan__header__details">
                        <div class="boxPlan__header__details__content">
                            <div>
                                <p>{{ 'synopticPlan.externalCode' | transloco }}</p>
                                <p>{{ this.selectedNode().dataNode.externalCode || 'N/A' }}</p>
                            </div>
                            <div>
                                <p>{{ 'synopticPlan.numberOfCassettes' | transloco }}</p>
                                <p>{{ synopticPlanInteractionService.cassetteCount() }}</p>
                            </div>
                        </div>
                    </div>
                }
            </div>

            @if (synopticPlanInteractionService.planType()) {
                <app-button
                    class="pointer-events-auto"
                    [icon]="['fas', 'arrow-down-to-line']"
                    [label]="'export' | transloco"
                    [type]="ButtonType.SECONDARY"
                    (onClick)="exportPlan(synopticPlanInteractionService.planType()!)" />
            }
        </div>

        <div class="boxPlan__header__filter__display flex flex-row ml-6 mt-4 gap-2 items-center justify-self-end">
            @if (homeService.isExternalPage() && !homeService.isExternalBoxPlanPage()) {
                <app-synoptic-window-button [windowPath]="RoutePathEnum.SYNOPTIC_PLAN" />
            }
            @if (isFiberingEditionAvailable()) {
                <div class="flex items-center gap-2 pl-2">
                    {{ 'synopticPlan.fiberingEdition' | transloco }}
                    <app-toggle
                        [checked]="false"
                        (toggled)="enterEdition.emit()" />
                </div>
            }
            @if (!homeService.isExternalBoxPlanPage()) {
                <app-button
                    class="pointer-events-auto"
                    [icon]="['fas', 'xmark']"
                    [type]="ButtonType.SECONDARY"
                    (onClick)="close.emit()" />
            }
        </div>
    </div>
    <div class="w-full bg-background">
        @if (planItems().length) {
            <div class="boxPlan__header">
                <app-select
                    [defaultValue]="selectedCassetteOption()"
                    [enableSort]="false"
                    [label]="'synopticPlan.cassette' | transloco"
                    [options]="cassetteOptions()"
                    [placeholder]="'synopticPlan.chooseCassette'"
                    (optionSelected)="selectCassette($event[0])" />
            </div>
        }

        @if (planItems().length && synopticPlanInteractionService.planType() === PlanTypeEnum.BAY) {
            <app-bay-drawer-navigation
                class="w-full"
                [drawerPosition]="drawerPosition()"
                [drawerSize]="drawerSize()"
                [selectedNode]="selectedNode()" />
        }
    </div>
</div>
